(function($) {
    $.fn.iframeDotDigitalTitleInjector = function() {
        this.each(function() {
            const
                $iframe = $(this),
                title = $().isWelshPage() ? 'Ffurflen' : 'Form';

            $iframe.attr('title', title);
        });
        return this;
    };
}(jQuery));
